webpackJsonp([5],{

/***/ 124:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_actions__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_mutations__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_state__ = __webpack_require__(21);








__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */]);
var debug = "production" !== 'production';
/* harmony default export */ __webpack_exports__["default"] = (new __WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */].Store({
  state: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_5__store_state__["a" /* default */]),
  actions: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_3__store_actions__["a" /* default */]),
  mutations: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_4__store_mutations__["a" /* default */]),
  modules: {},
  strict: debug
}));

/***/ }),

/***/ 21:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  user_info: {
    user_id: '',
    email: '',
    user_name: '',
    gender: '',
    mobile: '',
    education: '',
    company: '',
    job: '',
    industry: '',
    introducation: '',
    hunter_verify: '',

    city: '',
    career: [],
    token: ''
  },
  alert: {
    text: '',
    type: 'success',
    show: false,
    duration: 0
  },
  loading: {
    show: false
  }
});

/***/ }),

/***/ 31:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);


/* harmony default export */ __webpack_exports__["a"] = ({
  alert: function alert(context, data) {
    console.log(data);
    data.show = true;
    context.commit('alert', data);
    if (data.duration !== 0) {
      setTimeout(function () {
        context.commit('alert', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, data, {
          show: false
        }));
      }, data.duration > 0 ? data.duration : 3000);
    }
  },
  loading: function loading(context, show) {
    var data = {
      show: show
    };
    context.commit('loading', data);
  }
});

/***/ }),

/***/ 32:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state__ = __webpack_require__(21);





/* harmony default export */ __webpack_exports__["a"] = ({
  updateUserInfo: function updateUserInfo(state, data) {
    state.user_info = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.user_info, JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data)));
  },
  clearUserInfo: function clearUserInfo(state, data) {
    state.user_info = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.user_info);
  },
  alert: function alert(state, data) {
    state.alert = data;
  },
  loading: function loading(state, data) {
    state.loading = data;
  }
});

/***/ })

},[124]);


// WEBPACK FOOTER //
// src/js/store.0412f51cc322f5ec9f5d.js